export const validationErrorType = {
  valid: 1,
  empty: 2,
};
